import { StandardComp } from "../atoms/standardComp"
import { RapportKpiComp } from "../components/kpiComp"
import { GraphComp } from "../components/graphComp"
import { getAPI, postAPI, updateAPI } from "../api/api"
import { useEffect, useState } from "react"
import { loadScript } from "pdfjs-dist"

export function ReportsOverview({ graphDataset, kpiContent, keys, allReports, loadStats, activeGraphId,courses, selectedCourses}) {
const [reportKPI, setReportKPI] = useState([{id_report:0, name:"Voeg kpi toe", total_metric:""}])
const [period, setPeriod] = useState(6)
const [activeGraph, setActiveGraph] = useState(0)
const [graphData, setGraphData] = useState([])
const [activeKPI, setActiveKPI] = useState(0) 
const [reportOptions, setReportOptions] = useState([{pretty_name:"", id_report:1}]) 

useEffect(() => console.log("these are the courses",selectedCourses) ,[selectedCourses])
  const loadReports = async () => {
    const query = `api/reports/reports?courses=[${selectedCourses}]`
    const reports = await getAPI(query)
    console.log(reports.data)
    if(reports.data.length == 0){
      return 
    }
    setReportKPI(reports.data)
  }
  
  const loadGraph = async (report) => {
    console.log('test1', report)
    const query = `api/reports/reports/graph?id_report=${report?.id_report}&period=${period}`
    const graph = await getAPI(query)
    // setGraphData(graph.data)
    setGraphData([])
  }
  const loadReportOptions = async () => {
    const query = `api/reports/reports/options/available`
    const option = await getAPI(query)
    setReportOptions(option.data)
  }
  const handleActiveGraph = (index) => {
    setActiveGraph(index)
    loadGraph(reportKPI[index])

  }
  useEffect(() => {
    loadReports()
    loadReportOptions()
    loadGraph(reportKPI[activeKPI])
  },[])

  const swap = async (id, index) => {
    console.log(reportKPI[index], index)
    const query = "api/reports/reports/update"
    const body = {"id_report":id,"old_id_report":reportKPI[index].id_report, period:period, order:index}
    console.log("new_body",body)
    await updateAPI(query,body)
  }

  const add = async (id, index) => {
    console.log(reportKPI[index], index)
    const query = "api/reports/reports/add"
    const body = {"id_report":id, period:period, order:index}
    console.log("new_body",body)
    await postAPI(query,body)
    await loadReports()
  }

  const completeSwap = async (id, index) =>{
    await swap(id, index)
    await loadReports()
  }
  return (
    <StandardComp
      editClass={"standard-margin phone-reports-stats no-padding"}
      content={
        <div className={"horizontal phone-reports-stats"} style={{ alignItems: "stretch" }}>
          <div className={"vertical stats-grid"} style={{ width: "40%" }}>
            {reportKPI.map((row, index) => {
       
              return (
                <RapportKpiComp
                  editClass={"no-margin no-rounded standard-border-top rapport-kpi-comp"}
                  style={{ paddingRight: "1rem" }}
                  key={row.order}
                  title={row.name }
                  value={row.total_metric || 0}
                  percentage={row.difference_status}
                  icon2={row.metric_icon}
                  dropdownOptions={reportOptions.map((report) => ({
                    id: report.id_report,
                    content: report.pretty_name}))}
                  onSelectDropdown={(id) => row.total_metric != "" ? completeSwap(id,index ) : add(id,index)}
                  onToggleGraph={() => handleActiveGraph(index)}
                  isActive={activeGraph === index}
                  unit={row.unit}
                />
              );
            })}
            {(reportKPI.length < 4 && reportKPI.length > 1) &&
                       <RapportKpiComp
                  editClass={"no-margin no-rounded standard-border-top rapport-kpi-comp"}
                  style={{ paddingRight: "1rem" }}
                  key={reportKPI.length}
                  title={"Voeg KPI toe"}
                  value={""}
                  percentage={0}
                  icon2={''}
                  dropdownOptions={reportOptions.map((report) => ({
                    id: report.id_report,
                    content: report.pretty_name}))}
                  onSelectDropdown={(id) =>add(id,reportKPI.length)}
                  onToggleGraph={() =>{}}
                  isActive={activeGraph === 0}
                  unit={'leeg'}
                />
            }
          </div>
          <div
            className={"standard-padding standard-border-left reports-graph"}
            style={{ alignContent: "center", width: "calc(100% - 40%)", height: "unset" }}
          >
            <GraphComp   setPeriod={setPeriod} period={period} dataset={{ graph: graphData, courses:courses.filter(course => selectedCourses.includes(course.id_course)) }} graph={"rapport"} title={reportKPI[activeGraph].name} />
          </div>
        </div>
      }
    />
  );
}
